import _taggedTemplateLiteral from '../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js';
import styled from 'styled-components';
import { Flex, spaceMixin, token, Text, Paragraph, TextButton, IconArrowRightOutline, DetailedIconSearchHeart, DetailedIconBrainGear } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { trackGAMortgageEvent } from '../analytics.js';
import { isHappyOutcome } from '../calculations.js';
import { getFindHomeUrl, getDownPaymentAssistanceUrl } from '../url.js';
import jsxRuntime from '../../../node_modules/react/jsx-runtime.js';

var _templateObject;
var HAPPY_CONTENT = {
  icon: /*#__PURE__*/jsxRuntime.jsx(DetailedIconSearchHeart, {}),
  title: 'Find your new home',
  description: 'Take a look at listings in your area and get connected to a top-rated Premier Agent™.',
  urlText: 'See what’s in your budget',
  getUrl: getFindHomeUrl
};
var UNHAPPY_CONTENT = {
  icon: /*#__PURE__*/jsxRuntime.jsx(DetailedIconBrainGear, {}),
  title: 'Learn about down payment assistance',
  description: 'Down payment assistance can help you lower the amount you need to save for a down payment.',
  urlText: 'See if you’re eligible',
  getUrl: getDownPaymentAssistanceUrl
};
var Wrapper = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", ";\n    border: 1px solid ", ";\n    box-shadow: 0 2px 4px ", ";\n    background-color: ", ";\n"])), spaceMixin('md'), token('colors.borderLight'), token('colors.borderLight'), token('colors.backgroundBlue'));
var getContent = function getContent(outcome) {
  return isHappyOutcome(outcome) ? HAPPY_CONTENT : UNHAPPY_CONTENT;
};
var SecondaryCta = function SecondaryCta(_ref) {
  var outputs = _ref.outputs;
  useEffect(function () {
    if (outputs.outcome) {
      var _getContent = getContent(outputs.outcome),
        _urlText = _getContent.urlText;
      trackGAMortgageEvent('Budget Calculator: Impression', "Calculator Secondary CTA \"".concat(_urlText, "\""));
    }
  }, [outputs.outcome]);
  if (!outputs.outcome) {
    return null;
  }
  var _getContent2 = getContent(outputs.outcome),
    icon = _getContent2.icon,
    title = _getContent2.title,
    description = _getContent2.description,
    urlText = _getContent2.urlText,
    getUrl = _getContent2.getUrl;
  return /*#__PURE__*/jsxRuntime.jsxs(Wrapper, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    children: [icon, /*#__PURE__*/jsxRuntime.jsx(Text, {
      fontType: "bodyHeading",
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx(Paragraph, {
      fontType: "bodySmall",
      marginY: "xs",
      children: description
    }), /*#__PURE__*/jsxRuntime.jsx(TextButton, {
      as: "a",
      href: getUrl(),
      onClick: function onClick() {
        return trackGAMortgageEvent('Budget Calculator: Click', "Calculator Secondary CTA \"".concat(urlText, "\""));
      },
      icon: /*#__PURE__*/jsxRuntime.jsx(IconArrowRightOutline, {}),
      iconPosition: "end",
      children: urlText
    })]
  });
};
SecondaryCta.propTypes = {
  outputs: PropTypes.object
};
var SecondaryCta$1 = SecondaryCta;

export { SecondaryCta$1 as default };
//# sourceMappingURL=SecondaryCta.js.map
